import Vue from 'vue'

// Global Mixins
import Authorization from '@/mixins/Authorization'
import Modals from '@/mixins/Modals'
import Helpers from '@/mixins/Helpers'

Vue.mixin(Authorization)
Vue.mixin(Helpers)
Vue.mixin(Modals)
